'use strict';

var namespace = 'shapeJSRT:';

module.exports = {
  SHAPE_JS_UPDATE_PARAMS: namespace + 'SHAPE_JS_UPDATE_PARAMS',
  SHAPE_JS_MATERIAL_SELECTED: namespace + 'SHAPE_JS_MATERIAL_SELECTED'
};
